import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Plus } from 'lucide-react';
import styles from '@/components/action-bar/action-bar.module.css';
import LibraryDrawer from '@/components/library-drawer';

const ActionBar = () => {
	const [isOpen, handlers] = useDisclosure(false);

	const handleOpen = () => {
		handlers.open();
	};
	const handleClose = () => {
		handlers.close();
	};

	return (
		<>
			<div className={styles.wrapper}>
				<Button
					leftSection={<Plus />}
					onClick={handleOpen}
					variant="light"
				>
					Add from Library
				</Button>
			</div>
			<LibraryDrawer
				isOpen={isOpen}
				onClose={handleClose}
			/>
		</>
	);
};

export default ActionBar;
